<template>
  <section class="articles-section o-container o-container--responsive mv-64">
    <div class="u-align-center mv-64">
      <bl-text-av tag="h2" variation="heading-32">
        {{ $options.articles.title }}
      </bl-text-av>
    </div>
    <basic-carousel :total-item="$options.articles.items.length" :item-per-page="2">
      <a v-for="(item, idx) in $options.articles.items" :slot="`item-${idx + 1}`" :key="idx" :href="item.url">
        <bl-flex-container-mv :gutter="32" align-items="center">
          <bl-flex-item-av>
            <new-webp-image-container
              :src="item.image"
              :styles="'height: 262px; width: 170px; border-radius: 8px;'"
              :alt="item.title"
              :is-ssr="isSSR"
              loading="lazy"
            />
          </bl-flex-item-av>
          <bl-flex-item-av>
            <bl-text-av variation="heading-24" class="mb-24">
              {{ item.title }}
            </bl-text-av>
            <bl-text-av variation="body-16" style="font-size: 20px">
              {{ item.excerpt }}
            </bl-text-av>
          </bl-flex-item-av>
        </bl-flex-container-mv>
      </a>
    </basic-carousel>
  </section>
</template>
<script>
/* istanbul ignore file */
import BlTextAv from '@bukalapak/bazaar-dweb-2/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexItemAv';
import { Articles as articles } from 'shared/modules/seo/Homepage';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';
import BasicCarousel from 'seo-desktop/components/BasicCarousel';

export default {
  name: 'Articles',

  articles,

  components: {
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    NewWebpImageContainer,
    BasicCarousel,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },
  },
};
</script>
<style lang="scss" scoped>
.articles-section {
  /deep/ img {
    max-width: none;
  }
}
</style>
